const profileConfig = {
  tabs: [
    {
      id: "profile",
      label: "Profile",
      icon: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
    },
    {
      id: "cars",
      label: "My Cars",
      icon: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.8 17 8 17 8h-2c0 1.5.5 3 1.5 4.1M3 17h-2c-.6 0-1-.4-1-1v-3c0-.9.7-1.7 1.5-1.9C3.3 10.8 5 8 5 8h2c0 1.5-.5 3-1.5 4.1M7 17h10M9 12h6",
    },
    {
      id: "wishlist",
      label: "Saved Cars",
      icon: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z",
    },
    {
      id: "testDrives",
      label: "Test Drives",
      icon: "M7 17h10M5 8h2c0 1.5.5 3 1.5 4.1M19 8h-2c0 1.5-.5 3-1.5 4.1M3 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9M21 17h-2c-.6 0-1-.4-1-1v-3c0-.9.7-1.7 1.5-1.9",
    },
    {
      id: "orders",
      label: "Protection Orders",
      icon: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z",
    },
    {
      id: "kyc",
      label: "Verification",
      icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2z",
    },
    {
      id: "password",
      label: "Security",
      icon: "M12 15v2m-6-4h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2zm10-4a4 4 0 0 0-8 0v4h8V7z",
    },
  ],

  sections: {
    profile: {
      badge: "Personal Information",
      title: "Profile Settings",
      subtitle: "Manage your account details and preferences",
      saveButton: "Save Changes",
      otp: {
        header: "Verify your new email address",
        placeholder: "Enter 6-digit code",
        sendLabel: "Send Code",
        sentLabel: "Code Sent",
      },
      verifiedLabel: "Verified",
    },

    cars: {
      badge: "My Collection",
      title: "My Vehicles",
      subtitle: "Manage your car listings and track performance",
      emptyState: {
        title: "No vehicles in your garage",
        description: "Start listing your cars to reach potential buyers",
        buttonLabel: "Add Your First Car",
        buttonPath: "/upload-car",
      },
      statusLabels: {
        approved: "Approved",
        awaiting: "Pending",
      },
      quickViewLabel: "Quick View",
      viewsSuffix: "views",
    },

    wishlist: {
      badge: "Saved Listings",
      title: "Saved Cars",
      subtitle: "Cars you have saved for later — compare or contact sellers anytime",
      emptyState: {
        title: "No saved cars yet",
        description: "Tap the heart icon on any car to save it here",
        buttonLabel: "Browse Cars",
        buttonPath: "/cars",
      },
      removeLabel: "Remove",
      compareLabel: "Compare Selected",
      viewLabel: "View Details",
    },

    testDrives: {
      badge: "Bookings",
      title: "Test Drive Bookings",
      subtitle: "Track your scheduled test drives and booking status",
      emptyState: {
        title: "No test drives booked yet",
        description: "Book a test drive from any car listing to see it here",
        buttonLabel: "Browse Cars",
        buttonPath: "/cars",
      },
      carLabel: "Vehicle",
      dateLabel: "Preferred Date",
      timeLabel: "Preferred Time",
      locationLabel: "Location",
      partnerLabel: "Assigned Partner",
      bookedLabel: "Booked On",
      viewCarLabel: "View Car",
      statusLabels: {
        requested: "Requested",
        assigned: "Assigned",
        confirmed: "Confirmed",
        completed: "Completed",
        cancelled: "Cancelled",
      },
    },

    kyc: {
      badge: "Identity Verification",
      title: "KYC Verification",
      subtitle: "Complete verification to unlock premium features",
      selectTypeLabel: "Select Document Type",
      chooseFileLabel: "Choose File",
      uploadSuccessLabel: "File uploaded successfully",
      submitLabel: "Submit for Verification",
    },

    password: {
      badge: "Account Security",
      title: "Password & Security",
      subtitle: "Keep your account secure with a strong password",
      strengthLabels: ["Weak", "Medium", "Strong"],
      fieldLabels: {
        current: "Current Password",
        new: "New Password",
        confirm: "Confirm New Password",
      },
      updateButton: "Update Password",
      securityTipsTitle: "Security Tips",
      twoFactor: {
        title: "Two-Factor Authentication",
        description: "Add an extra layer of security",
        buttonLabel: "Enable 2FA",
      },
    },
  },

  profileFields: [
    { name: "name", label: "Full Name", type: "text", editable: true, icon: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" },
    { name: "email", label: "Email Address", type: "email", editable: true, icon: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z M22,6 12,13 2,6" },
    { name: "phone", label: "Phone Number", type: "tel", editable: true, icon: "M5 2h14a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z M12 18h.01" },
  ],

  passwordSettings: {
    requirements: [
      { label: "8+ characters", met: true },
      { label: "1 number", met: true },
      { label: "1 uppercase", met: false },
      { label: "1 special char", met: false },
    ],
    securityTips: [
      "Use a unique password not used elsewhere",
      "Enable two-factor authentication",
      "Never share your password with anyone",
      "Update password every 3 months",
      "Avoid using personal information",
    ],
  },

  kycForm: {
    idProof: {
      label: "Government ID",
      icon: {
        viewBox: "0 0 24 24",
        paths: [
          { type: "path", d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" },
          { type: "polyline", points: "14 2 14 8 20 8" },
        ],
      },
      options: [
        { value: "aadhar", label: "Aadhar Card" },
        { value: "passport", label: "Passport" },
        { value: "drivers_license", label: "Driver's License" },
      ],
    },
    addressProof: {
      label: "Address Proof",
      icon: {
        viewBox: "0 0 24 24",
        paths: [
          {
            type: "path",
            d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6",
          },
        ],
      },
      options: [
        { value: "utility_bill", label: "Utility Bill" },
        { value: "bank_statement", label: "Bank Statement" },
        { value: "rent_agreement", label: "Rent Agreement" },
      ],
    },
  },
};

export default profileConfig;
